import { z } from 'zod';
import { GRANULARITIES, PERIOD_PRESETS } from '../time/period';
import { amountSchema, ENTRY_TYPES, idSchema } from './api.schema';

export const monthKeySchema = z.string().regex(/^\d{4}-(0[1-9]|1[0-2])$/, 'Format bulan YYYY-MM');

export const reportQuerySchema = z
  .object({
    period: z.enum(PERIOD_PRESETS).optional(),
    from: z.coerce.date().optional(),
    to: z.coerce.date().optional(),
    granularity: z.enum(GRANULARITIES).optional(),
    type: z.enum(ENTRY_TYPES).optional(),
  })
  .refine((q) => (q.from === undefined) === (q.to === undefined), {
    message: 'from dan to harus diisi bersamaan',
  })
  .refine((q) => !q.from || !q.to || q.from < q.to, { message: 'from harus sebelum to' })
  .refine((q) => !q.from || !q.to || q.to.getTime() - q.from.getTime() <= 3 * 366 * 86_400_000, {
    message: 'Rentang maksimal 3 tahun',
  });
export type ReportQuery = z.output<typeof reportQuerySchema>;
export type ReportQueryInput = z.input<typeof reportQuerySchema>;

export const cashflowQuerySchema = z.object({ months: z.coerce.number().int().min(1).max(24).default(6) });

export const budgetMonthQuerySchema = z.object({ month: monthKeySchema.optional() });

export const budgetUpsertSchema = z.object({
  categoryId: idSchema,
  month: monthKeySchema,
  limit: amountSchema,
});
export type BudgetUpsertInput = z.input<typeof budgetUpsertSchema>;

export const budgetCopySchema = z.object({ month: monthKeySchema });
